// source: authz/permissions.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

goog.exportSymbol('proto.authz.CAPABILITY', null, global);
goog.exportSymbol('proto.authz.PERMISSION_RULE', null, global);
goog.exportSymbol('proto.authz.Permission', null, global);
goog.exportSymbol('proto.authz.Permissions', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.Permission = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.authz.Permission, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.Permission.displayName = 'proto.authz.Permission';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.authz.Permissions = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.authz.Permissions.repeatedFields_, null);
};
goog.inherits(proto.authz.Permissions, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.authz.Permissions.displayName = 'proto.authz.Permissions';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.Permission.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.Permission.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.Permission} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.Permission.toObject = function(includeInstance, msg) {
  var f, obj = {
    capability: jspb.Message.getFieldWithDefault(msg, 1, 0),
    rule: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.Permission}
 */
proto.authz.Permission.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.Permission;
  return proto.authz.Permission.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.Permission} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.Permission}
 */
proto.authz.Permission.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.authz.CAPABILITY} */ (reader.readEnum());
      msg.setCapability(value);
      break;
    case 2:
      var value = /** @type {!proto.authz.PERMISSION_RULE} */ (reader.readEnum());
      msg.setRule(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.Permission.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.Permission.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.Permission} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.Permission.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCapability();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getRule();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional CAPABILITY capability = 1;
 * @return {!proto.authz.CAPABILITY}
 */
proto.authz.Permission.prototype.getCapability = function() {
  return /** @type {!proto.authz.CAPABILITY} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.authz.CAPABILITY} value
 * @return {!proto.authz.Permission} returns this
 */
proto.authz.Permission.prototype.setCapability = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional PERMISSION_RULE rule = 2;
 * @return {!proto.authz.PERMISSION_RULE}
 */
proto.authz.Permission.prototype.getRule = function() {
  return /** @type {!proto.authz.PERMISSION_RULE} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.authz.PERMISSION_RULE} value
 * @return {!proto.authz.Permission} returns this
 */
proto.authz.Permission.prototype.setRule = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.authz.Permissions.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.authz.Permissions.prototype.toObject = function(opt_includeInstance) {
  return proto.authz.Permissions.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.authz.Permissions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.Permissions.toObject = function(includeInstance, msg) {
  var f, obj = {
    permissionsList: jspb.Message.toObjectList(msg.getPermissionsList(),
    proto.authz.Permission.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.authz.Permissions}
 */
proto.authz.Permissions.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.authz.Permissions;
  return proto.authz.Permissions.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.authz.Permissions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.authz.Permissions}
 */
proto.authz.Permissions.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.authz.Permission;
      reader.readMessage(value,proto.authz.Permission.deserializeBinaryFromReader);
      msg.addPermissions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.authz.Permissions.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.authz.Permissions.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.authz.Permissions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.authz.Permissions.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPermissionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.authz.Permission.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Permission permissions = 1;
 * @return {!Array<!proto.authz.Permission>}
 */
proto.authz.Permissions.prototype.getPermissionsList = function() {
  return /** @type{!Array<!proto.authz.Permission>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.authz.Permission, 1));
};


/**
 * @param {!Array<!proto.authz.Permission>} value
 * @return {!proto.authz.Permissions} returns this
*/
proto.authz.Permissions.prototype.setPermissionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.authz.Permission=} opt_value
 * @param {number=} opt_index
 * @return {!proto.authz.Permission}
 */
proto.authz.Permissions.prototype.addPermissions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.authz.Permission, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.authz.Permissions} returns this
 */
proto.authz.Permissions.prototype.clearPermissionsList = function() {
  return this.setPermissionsList([]);
};


/**
 * @enum {number}
 */
proto.authz.PERMISSION_RULE = {
  UNKNOWN: 0,
  IF_OWNER: 1,
  ALWAYS: 2,
  IF_TRUSTERO_USER: 3,
  NEVER: 4,
  IF_OWNER_OR_ASSIGNEE: 5,
  IF_GRANTED_PERMISSION: 6,
  IF_DENIED_PERMISSION: 7
};

/**
 * @enum {number}
 */
proto.authz.CAPABILITY = {
  NONE: 0,
  CAN_VIEW_CONTROLS: 1000,
  CAN_ADD_CONTROLS: 1001,
  CAN_UPDATE_CONTROLS: 1002,
  CAN_DELETE_CONTROLS: 1003,
  CAN_VIEW_CONTROL_NOTES: 1004,
  CAN_REPLACE_CONTROLS: 1005,
  CAN_UPDATE_CONTROL_STATUS: 1006,
  CAN_UPDATE_CONTROL_OBJECTIVE: 1007,
  CAN_UPDATE_CONTROL_PROCEDURE: 1008,
  CAN_UPDATE_CONTROL_RESPONSIBILITY: 1009,
  CAN_UPDATE_CONTROL_REQUIRED_EVIDENCE: 1010,
  CAN_UPDATE_CONTROL_TEST_PROCEDURES: 1011,
  CAN_UPDATE_CONTROL_OWNER: 1012,
  CAN_LINK_CONTROL_FRAMEWORKS: 1013,
  CAN_LINK_CONTROL_EVIDENCE: 1014,
  CAN_LINK_CONTROL_REQUESTS: 1015,
  CAN_UPDATE_CONTROL_NAME: 1016,
  CAN_UPDATE_CONTROL_ID: 1017,
  CAN_UPDATE_CONTROL_POLICY: 1018,
  CAN_LINK_CONTROL_RISKS: 1019,
  CAN_TOGGLE_CONTROL_USES_NEW_AUDIT_SCAN: 1020,
  CAN_UPDATE_CONTROL_GENERAL_GUIDANCE: 1021,
  CAN_VIEW_POLICIES: 2000,
  CAN_ADD_POLICIES: 2001,
  CAN_UPDATE_POLICIES: 2002,
  CAN_DELETE_POLICIES: 2003,
  CAN_UPDATE_POLICY_RESPONSIBILITY: 2004,
  CAN_UPDATE_POLICY_OWNER: 2005,
  CAN_UPDATE_POLICY_DEPARTMENT: 2006,
  CAN_LINK_POLICY_CONTROLS: 2007,
  CAN_VIEW_POLICY_DOCS: 2008,
  CAN_ADD_POLICY_DOCS: 2009,
  CAN_UPDATE_POLICY_DOCS: 2010,
  CAN_DELETE_POLICY_DOCS: 2011,
  CAN_UPDATE_POLICY_NAME: 2012,
  CAN_UPDATE_POLICY_DESCRIPTION: 2013,
  CAN_ADD_POLICY_DOCS_FROM_TEMPLATE: 2014,
  CAN_VIEW_EVIDENCE: 3000,
  CAN_ADD_EVIDENCE: 3001,
  CAN_UPDATE_EVIDENCE: 3002,
  CAN_DELETE_EVIDENCE: 3003,
  CAN_LINK_EVIDENCE_CONTROLS: 3004,
  CAN_LINK_EVIDENCE_REQUESTS: 3005,
  CAN_UPDATE_EVIDENCE_CAPTION: 3006,
  CAN_UPDATE_EVIDENCE_RELEVANT_DATE: 3007,
  CAN_VIEW_OUT_OF_RANGE_EVIDENCE: 3008,
  CAN_VIEW_RISKS: 4000,
  CAN_ADD_RISKS: 4001,
  CAN_UPDATE_RISKS: 4002,
  CAN_DELETE_RISKS: 4003,
  CAN_LINK_RISK_CONTROLS: 4004,
  CAN_LINK_RISK_VENDORS: 4005,
  CAN_UPDATE_RISK_NAME: 4006,
  CAN_UPDATE_RISK_ID: 4007,
  CAN_VIEW_RISK_CATEGORIES: 4008,
  CAN_ADD_RISK_CATEGORIES: 4009,
  CAN_UPDATE_RISK_CATEGORIES: 4010,
  CAN_DELETE_RISK_CATEGORIES: 4011,
  CAN_UPDATE_RISK_STATUS: 4012,
  CAN_UPDATE_RISK_OWNER: 4013,
  CAN_UPDATE_RISK_DEPARTMENT: 4014,
  CAN_ADD_RISK_STATUSES: 4015,
  CAN_UPDATE_RISK_STATUSES: 4016,
  CAN_DELETE_RISK_STATUSES: 4017,
  CAN_VIEW_SERVICES: 5000,
  CAN_ADD_SERVICES: 5001,
  CAN_UPDATE_SERVICES: 5002,
  CAN_DELETE_SERVICES: 5003,
  CAN_EXCLUDE_SERVICES: 5004,
  CAN_EXCLUDE_SERVICE_INSTANCES: 5005,
  CAN_UPDATE_SERVICE_ROLES: 5006,
  CAN_VIEW_RECEPTORS: 6000,
  CAN_ADD_RECEPTORS: 6001,
  CAN_UPDATE_RECEPTORS: 6002,
  CAN_DELETE_RECEPTORS: 6003,
  CAN_ACTIVATE_RECEPTORS: 6004,
  CAN_DEACTIVATE_RECEPTORS: 6005,
  CAN_UPDATE_RECEPTOR_CREDENTIALS: 6006,
  CAN_UPDATE_RECEPTOR_CONFIG: 6007,
  CAN_COLLECT_RECEPTOR_EVIDENCE: 6008,
  CAN_LINK_RECEPTOR_EVIDENCE_CONTROLS: 6009,
  CAN_VIEW_FRAMEWORKS: 7000,
  CAN_ADD_FRAMEWORKS: 7001,
  CAN_UPDATE_FRAMEWORKS: 7002,
  CAN_REMOVE_FRAMEWORKS: 7003,
  CAN_ENABLE_FRAMEWORKS: 7004,
  CAN_VIEW_AUDITS: 8000,
  CAN_ADD_AUDITS: 8001,
  CAN_UPDATE_AUDITS: 8002,
  CAN_DELETE_AUDITS: 8003,
  CAN_VIEW_CONTINUOUS_COMPLIANCE: 8004,
  CAN_CLOSE_AUDITS: 8005,
  CAN_DOWNLOAD_AUDIT_REPORT: 8006,
  CAN_LINK_AUDIT_CONTROLS: 8007,
  CAN_UPLOAD_AUDIT_REPORT: 8008,
  CAN_VIEW_REQUESTS: 9000,
  CAN_ADD_REQUESTS: 9001,
  CAN_UPDATE_REQUESTS: 9002,
  CAN_DELETE_REQUESTS: 9003,
  CAN_UPDATE_REQUEST_STATUS: 9004,
  CAN_UPDATE_REQUEST_OWNER: 9005,
  CAN_UPDATE_REQUEST_DUE_DATE: 9006,
  CAN_LINK_REQUEST_CONTROLS: 9007,
  CAN_LINK_REQUEST_EVIDENCE: 9008,
  CAN_VIEW_REPORTS: 10000,
  CAN_CREATE_REPORTS: 10001,
  CAN_UPDATE_REPORTS: 10002,
  CAN_DELETE_REPORTS: 10003,
  CAN_VIEW_ROADMAP: 11000,
  CAN_UPDATE_ROADMAP: 11001,
  CAN_VIEW_DASHBOARDS: 12000,
  CAN_ADD_DASHBOARDS: 12001,
  CAN_UPDATE_DASHBOARDS: 12002,
  CAN_DELETE_DASHBOARDS: 12003,
  CAN_VIEW_CHILD_ACCOUNT_DASHBOARDS: 12004,
  CAN_VIEW_USERS: 13000,
  CAN_INVITE_USERS: 13001,
  CAN_UPDATE_USERS: 13002,
  CAN_REMOVE_USERS: 13003,
  CAN_VIEW_SCOPE: 14000,
  CAN_UPDATE_SCOPE: 14001,
  CAN_ADD_PROVIDER: 14003,
  CAN_VIEW_ACTIVITY_LOG: 15000,
  CAN_DOWNLOAD_WORKPAPERS: 15001,
  CAN_VIEW_INDEXING_STATUS: 15002,
  CAN_VIEW_TRUSTERO_AI_USAGE: 15003,
  CAN_VIEW_AUDIT_SCANS: 16000,
  CAN_START_AUDIT_SCANS: 16001,
  CAN_UPDATE_AUDIT_SCANS: 16002,
  CAN_DELETE_AUDIT_SCANS: 16003,
  CAN_CANCEL_AUDIT_SCANS: 16004,
  CAN_REVIEW_AUDIT_SCANS: 16005,
  CAN_MARK_CONTROL_TESTS_CURRENT: 16006,
  CAN_IMPORT_CONTROL_TESTS: 16007,
  CAN_VIEW_CHATS: 17000,
  CAN_CREATE_CHATS: 17001,
  CAN_UPDATE_CHATS: 17002,
  CAN_DELETE_CHATS: 17003,
  CAN_UPDATE_CHAT_CONTEXT: 17004,
  CAN_VIEW_CONTENT_MANAGEMENT: 18000,
  CAN_VIEW_ACCESS_MANAGEMENT: 18001,
  CAN_MANAGE_ACCESS: 18002,
  CAN_MANAGE_NOTIFICATIONS: 18003,
  CAN_PUBLISH_CONTENT: 18004,
  CAN_VIEW_QUESTIONNAIRES: 19000,
  CAN_ADD_QUESTIONNAIRES: 19001,
  CAN_UPDATE_QUESTIONNAIRES: 19002,
  CAN_DELETE_QUESTIONNAIRES: 19003,
  CAN_UPLOAD_KNOWLEDGE_BASE: 19004,
  CAN_DOWNLOAD_KNOWLEDGE_BASE: 19005,
  CAN_DELETE_KNOWLEDGE_BASE: 19006,
  CAN_UPDATE_ANSWER: 19007,
  CAN_ACCEPT_ANSWER: 19008,
  CAN_ACCEPT_QUESTIONNAIRE: 19009,
  CAN_ADD_QUESTIONNAIRE_TO_KNOWLEDGE_BASE: 19010,
  CAN_SEND_QUESTIONNAIRE: 19011,
  CAN_COMMENT_ON_QUESTIONNAIRE: 19012,
  CAN_VIEW_ACCOUNT_SETTINGS: 20000,
  CAN_UPDATE_TIMESTAMP_VALIDATION: 20003,
  CAN_UPDATE_DATE_LIMIT: 20004,
  CAN_MANAGE_REPORTING_CONSENT: 20006,
  CAN_VIEW_API_TOKENS: 20007,
  CAN_MANAGE_API_TOKENS: 20008,
  CAN_VIEW_VENDORS: 21000,
  CAN_ADD_VENDORS: 21001,
  CAN_UPDATE_VENDORS: 21002,
  CAN_DELETE_VENDORS: 21003,
  CAN_VIEW_VENDOR_ATTESTATIONS: 21004,
  CAN_ADD_VENDOR_ATTESTATIONS: 21005,
  CAN_DELETE_VENDOR_ATTESTATIONS: 21006,
  CAN_DOWNLOAD_VENDOR_ATTESTATIONS: 21007,
  CAN_LINK_VENDOR_RISKS: 21008,
  CAN_VIEW_GRC_DOCUMENTS: 22000,
  CAN_ADD_GRC_DOCUMENTS: 22001,
  CAN_UPDATE_GRC_DOCUMENTS: 22002,
  CAN_DELETE_GRC_DOCUMENTS: 22003,
  CAN_LIST_GRC_DOCUMENTS: 22004,
  CAN_VIEW_PLAYBOOKS: 23000,
  CAN_CREATE_PLAYBOOKS: 23001,
  CAN_UPDATE_PLAYBOOKS: 23002,
  CAN_DELETE_PLAYBOOKS: 23003,
  CAN_RUN_PLAYBOOKS: 23004,
  CAN_VIEW_ACCESS_ROLES: 24000,
  CAN_ADD_ACCESS_ROLES: 24001,
  CAN_UPDATE_ACCESS_ROLES: 24002,
  CAN_DELETE_ACCESS_ROLES: 24003,
  CAN_VIEW_DEPARTMENTS: 25000,
  CAN_ADD_DEPARTMENTS: 25001,
  CAN_UPDATE_DEPARTMENTS: 25002,
  CAN_DELETE_DEPARTMENTS: 25003,
  CAN_VIEW_COMPANY_INFO: 26000,
  CAN_UPDATE_COMPANY_INFO: 26001,
  CAN_UPDATE_COMPANY_NAME: 26002,
  CAN_VIEW_COMPANY_INFO_DOCS: 26003,
  CAN_ADD_COMPANY_INFO_DOCS: 26004,
  CAN_UPDATE_COMPANY_INFO_DOCS: 26005,
  CAN_DELETE_COMPANY_INFO_DOCS: 26006,
  CAN_VIEW_SCHEDULES: 27000,
  CAN_ADD_SCHEDULES: 27001,
  CAN_UPDATE_SCHEDULES: 27002,
  CAN_DELETE_SCHEDULES: 27003,
  CAN_ENABLE_SCHEDULES: 27004,
  CAN_VIEW_CONTENT_VERSIONS: 28000,
  CAN_PUBLISH_CONTENT_VERSIONS: 28001,
  CAN_UPGRADE_CONTENT: 28002
};

goog.object.extend(exports, proto.authz);
